var exports = {
  "ChatApp": "ChatApp__KSlLoe",
  "Header": "Header__gVFV07",
  "HeaderContent": "HeaderContent__auJ9yz",
  "Title": "Title__aH93GN",
  "Description": "Description__XnhVaW",
  "Body": "Body___lk80W",
  "HistoryBody": "HistoryBody__QqcFhS",
  "HistoryState": "HistoryState__6WsV-f",
  "ConversationPanel": "ConversationPanel__x5SCrm",
  "EnvironmentSetup": "EnvironmentSetup__X97G6s",
  "ConversationBody": "ConversationBody__n_btpo",
  "EnvironmentSetupOverlay": "EnvironmentSetupOverlay__lJ61Kk",
  "DragOverlay": "DragOverlay__0LVqrO",
  "NativeTimelineFrame": "NativeTimelineFrame__0h8lL2",
  "NativeTimeline": "NativeTimeline__P0YLCt",
  "NativeTimelineContent": "NativeTimelineContent__qGEpp2",
  "TimelineScrollToBottomButton": "TimelineScrollToBottomButton__hTsc66",
  "QueuedMessagesRegion": "QueuedMessagesRegion__f75xFz",
  "QueuedMessagesWarning": "QueuedMessagesWarning__gmI0mw",
};

__webpack_require__.r(module.exports = exports);
